'use client';

import { JSX, useEffect } from 'react';

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

/**
 * App Router segment error UI (replaces legacy `500.tsx` runtime handling for uncaught render errors).
 */
export default function AppError({ error, reset }: ErrorProps): JSX.Element {
  useEffect(() => {
    console.error('App route error:', error);
  }, [error]);

  return (
    <div style={{ padding: 10 }}>
      <h1>500 Internal Server Error</h1>
      <p>There is a problem with the resource you are looking for, and it cannot be displayed.</p>
      <button type="button" onClick={() => reset()} aria-label='Try again'>
        Try again
      </button>
      <p>
        <a href="/">Go to the Home page</a>
      </p>
    </div>
  );
}
